import { routesPath } from '@router/routes';
import { WithUserRolesHoc } from '@components/HOC/WithUserRoles/WithUserRoles.hoc';
import { UserRoles } from '@dynamika-shared/types/auth';
import { Layout } from '@components/Layout/Layout';
import { UsersListPage } from '../pages/Users/UsersList/UsersListPage';
import { InvitationsListPage } from '../pages/Users/InvitationsList/InvitationsListPage';
import { Outlet, RouteObject } from 'react-router-dom';
import { UsersAndLogs } from '../pages/Users/UsersAndLogs/UsersAndLogs';

export const usersAndLogsSubRoutes = [
  {
    title: 'Users',
    path: routesPath.usersAndLogsUsers,
    element: <UsersListPage />,
  },
  {
    title: 'Logs',
    path: routesPath.usersAndLogsLogs,
    element: <></>,
  },
  {
    title: 'Invitations',
    path: routesPath.usersAndLogsInvitations,
    element: (
      <WithUserRolesHoc
        allowedRoles={[UserRoles.ADMIN, UserRoles.PROJECT_MANAGER]}
      >
        <InvitationsListPage />
      </WithUserRolesHoc>
    ),
    allowedRoles: [UserRoles.ADMIN, UserRoles.PROJECT_MANAGER],
  },
];

export const usersAndLogsRoutes = [
  {
    title: 'Users',
    path: routesPath.usersAndLogs,
    element: (
      <WithUserRolesHoc
        allowedRoles={[UserRoles.ADMIN, UserRoles.PROJECT_MANAGER, UserRoles.SUPPORT]}
      >
        <Layout>
          <UsersAndLogs>
            <Outlet />
          </UsersAndLogs>
        </Layout>
      </WithUserRolesHoc>
    ),
    children: usersAndLogsSubRoutes.map(route => {
      const parts = route.path.split('/');
      const lastPart = parts[parts.length - 1];
      return {
        ...route,
        path: lastPart,
      };
    }),
  },
] as unknown as RouteObject[];
